import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import { Button, ChoiceGroup, Modal } from "../design";

const CardSelect = (props) => {
  const {
    cardModal,
    setCardModal,
    setIsDomesticCard,
    isDomesticCard,
    proceedPayment,
  } = props;

  const { _t } = useTranslator();

  const handleClose = () => {
    setCardModal(false);
  };

  // isDomesticCard is true / false / null; the radio group needs a string
  const selected = haveValue(isDomesticCard)
    ? isDomesticCard
      ? "domestic"
      : "international"
    : "";

  return (
    <Modal
      open={cardModal}
      onClose={handleClose}
      size="sm"
      title={_t("typeofCard")}
      actionsLayout="stack"
      actions={
        <Button
          size="lg"
          disabled={!haveValue(isDomesticCard)}
          onClick={proceedPayment}
        >
          {_t("proceedWithPayment")}
        </Button>
      }
    >
      <ChoiceGroup
        name="card_type"
        layout="list"
        value={selected}
        onChange={(e) => setIsDomesticCard(e.target.value === "domestic")}
        options={[
          {
            value: "domestic",
            label: _t("creditCardEU"),
            aside: _t("free"),
          },
          {
            value: "international",
            label: _t("creditCardInternational"),
            aside: _t("3_5%ServiceCharges"),
          },
        ]}
      />
    </Modal>
  );
};

export default CardSelect;
